/* global axios */
import ApiClient from './ApiClient';

class GoogleCalendarAPI extends ApiClient {
  constructor() {
    super('google_calendar', { accountScoped: true });
  }

  // Connection escopada por funnel — todas as operacoes precisam de funnelId.
  // POST /api/v1/accounts/:account_id/funnels/:funnel_id/google_calendar/authorizations
  connect(funnelId) {
    return axios.post(`${this.baseUrl()}/funnels/${funnelId}/google_calendar/authorizations`);
  }

  status(funnelId) {
    return axios.get(`${this.baseUrl()}/funnels/${funnelId}/google_calendar/connection`);
  }

  update(funnelId, payload) {
    return axios.patch(`${this.baseUrl()}/funnels/${funnelId}/google_calendar/connection`, payload);
  }

  disconnect(funnelId) {
    return axios.delete(`${this.baseUrl()}/funnels/${funnelId}/google_calendar/connection`);
  }

  syncNow(funnelId) {
    return axios.post(`${this.baseUrl()}/funnels/${funnelId}/google_calendar/connection/sync_now`);
  }
}

export default new GoogleCalendarAPI();